// Environment configuration

// Get the API base URL from environment variable, fallback to localhost for development
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
